import _ from 'lodash';
import templateStr from 'text!./activity-schedule.html';
import moment from 'moment';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,


        scope: {
            activities: '=',
            showribbon: '='
        },
        controller: ['$scope', ($scope) => {
            $scope.showcompleteribbon = true;
            $scope.currentDate = moment();
            $scope.tomorrow = moment().add(1, 'days');
            $scope.endOfWeek = moment().endOf('week');

            filterActivities();

            $scope.showRibbon = function () {
                return typeof $scope.showribbon === 'undefined' ? true : $scope.showribbon;
            };

            function filterActivities() {
                $scope.activitiesToday = [];
                $scope.activitiesTomorrow = [];
                $scope.activitiesThisWeek = [];
                $scope.activitiesFuture = [];
                $scope.activitiesOverdue = [];
                $scope.activitiesComplete = [];
                if (angular.isDefined($scope.activities) && $scope.activities.length > 0) {
                    let filteredActivities = setActivitiesCompleted($scope.activities);
                    filteredActivities = setActivitiesOverdue(filteredActivities);
                    filteredActivities = setActivitiesToday(filteredActivities);
                    filteredActivities = setActivitiesTomorrow(filteredActivities);
                    filteredActivities = setActivitiesThisWeek(filteredActivities);
                    $scope.activitiesFuture = filteredActivities;
                }
            }

            function setActivitiesCompleted(activities) {
                activities.forEach((activity) => {
                    if (activity.status === 'complete') {
                        $scope.activitiesComplete.push(activity);
                    }
                });

                return _.difference(activities, $scope.activitiesComplete);
            }

            function setActivitiesOverdue(activities) {
                activities.forEach((activity) => {
                    if (!angular.isDefined(activity.dueDate) || $scope.currentDate.isAfter(activity.dueDate, 'day')) {
                        $scope.activitiesOverdue.push(activity);
                    }
                });

                return _.difference(activities, $scope.activitiesOverdue);
            }

            function setActivitiesToday(activities) {
                activities.forEach((activity) => {
                    if ($scope.currentDate.isSame(activity.dueDate, 'day')) {
                        $scope.activitiesToday.push(activity);
                    }
                });

                return _.difference(activities, $scope.activitiesToday);
            }

            function setActivitiesTomorrow(activities) {
                activities.forEach((activity) => {
                    if ($scope.tomorrow.isSame(activity.dueDate, 'day')) {
                        $scope.activitiesTomorrow.push(activity);
                    }
                });

                return _.difference(activities, $scope.activitiesTomorrow);
            }

            function setActivitiesThisWeek(activities) {
                activities.forEach((activity) => {
                    const dueDate = moment(activity.dueDate);
                    if (dueDate.isAfter($scope.tomorrow, 'day') && !(dueDate.isAfter($scope.endOfWeek, 'day'))) {
                        $scope.activitiesThisWeek.push(activity);
                    }
                });

                return _.difference(activities, $scope.activitiesThisWeek);
            }

            $scope.$watchCollection('activities', () => {
                filterActivities();
            });
        }]
    };
}];
